// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__18IOo","productName":"Table_productName__gPbU9"};